<script setup>
import { ref, onMounted, onUnmounted } from "vue";
import { useForm } from "@inertiajs/vue3";
import ButtonSubmit from "@/Components/ButtonSubmit.vue";

const form = useForm({
    name: "",
    email: "",
    phone: "",
    company_name: "",
    "g-recaptcha-response": "",
});

const validationErrors = ref({});
const recaptcha = ref(null);
const siteKey = "6LcAJvUqAAAAAIKTzx-mXRjqjZiAufVKDgB6K7dj";

// Phone number formatting
const formatPhoneNumber = () => {
    let phone = form.phone.replace(/\D/g, "");
    if (phone.startsWith("0")) {
        if (phone.length <= 3) {
            phone = phone;
        } else if (phone.length <= 6) {
            phone = phone.slice(0, 3) + " " + phone.slice(3);
        } else if (phone.length <= 10) {
            phone =
                phone.slice(0, 3) +
                " " +
                phone.slice(3, 6) +
                " " +
                phone.slice(6);
        }
    }
    form.phone = phone;
};

const renderRecaptcha = () => {
    if (recaptcha.value && window.grecaptcha) {
        window.grecaptcha.render(recaptcha.value, {
            sitekey: siteKey,
            callback: onCaptchaSuccess,
        });
    }
};

function onCaptchaSuccess(token) {
    form["g-recaptcha-response"] = token;
}

const validateForm = () => {
    validationErrors.value = {};
    if (!form.name) validationErrors.value.name = "សូមបញ្ចូលឈ្មោះ";

    // if (!form.email) validationErrors.value.email = "សូមបញ្ចូលអ៊ីមែល";
    // else if (!/\S+@\S+\.\S+/.test(form.email))
    //     validationErrors.value.email = "សូមបញ្ចូលអ៊ីមែលដែរត្រឹមត្រូវ";

    if (!form.phone) validationErrors.value.phone = "សូមបញ្ចូលលេខទូរសព្ទ";
    if (!form["g-recaptcha-response"])
        validationErrors.value.recaptcha = "សូមផ្ទៀងផ្ទាត់ reCAPTCHA";
    return Object.keys(validationErrors.value).length === 0;
};

onMounted(() => {
    if (window.grecaptcha) {
        renderRecaptcha();
    } else {
        window.addEventListener("grecaptchaLoaded", renderRecaptcha);
    }
});

onUnmounted(() => {
    window.removeEventListener("grecaptchaLoaded", renderRecaptcha);
});

const submit = async () => {
    if (!validateForm()) return;
    form.post(route("home.store"), {
        onSuccess: () => form.reset(),
    });
};
</script>

<template>
    <form
        @submit.prevent="submit"
        class="grid gap-y-3 p-6 md:p-10 bg-white shadow-article font-hanuman-sans"
    >
        <div class="flex flex-col justify-start gap-y-2">
            <label for="name">ឈ្មោះរបស់អ្នក <span class="text-danger">*</span></label>
            <input
                class="input-default"
                type="text" 
                id="name"
                v-model="form.name"
                placeholder="វិបុល ខេមរា"
            />
            <span v-if="validationErrors.name" class="text-danger text-xs">{{ validationErrors.name }}</span>
        </div>

        <div class="flex flex-col justify-start gap-y-2">
            <label for="phone">លេខទូរសព្ទ <span class="text-danger">*</span></label>
            <input
                class="input-default"
                type="text"
                id="phone"
                v-model="form.phone"
                placeholder="010 011 012"
                @input="formatPhoneNumber"
            />
            <span v-if="validationErrors.phone" class="text-danger text-xs">{{ validationErrors.phone }}</span>
        </div>

        <div class="flex flex-col justify-start gap-y-2">
            <label for="email">អុីមែលរបស់អ្នក</label>
            <input 
                class="input-default"
                type="text"
                id="email"
                v-model="form.email"
                placeholder="vibol.khemra@gmail.com"
            />
            <!-- <span v-if="validationErrors.email" class="text-danger text-xs">{{ validationErrors.email }}</span> -->
        </div>

        <div class="flex flex-col justify-start gap-y-2">
            <label for="company_name">ឈ្មោះក្រុមហ៊ុន</label>
            <input
                class="input-default"
                type="text"
                id="company_name"
                v-model="form.company_name"
                placeholder="988 ថេក ឯ.ក"
            />
        </div>

        <!-- reCAPTCHA widget -->
        <!-- <div class="input-box">
            <div ref="recaptcha" class="g-recaptcha"></div>
            <span v-if="validationErrors.recaptcha" class="text-danger">{{ validationErrors.recaptcha }}</span>
        </div> -->
        <div ref="recaptcha" class="g-recaptcha"></div>
        <input type="hidden" v-model="form['g-recaptcha-response']" />
        <span v-if="validationErrors.recaptcha" class="text-danger text-xs">{{ validationErrors.recaptcha }}</span>

        <ButtonSubmit :btnName="'បញ្ចូន'" />
    </form>
</template>
